import { post } from '@/utils/requests';

class Accurate {
  async getTwoDiff(param) {
    const res = await post('/v1/workflow/accurate', param);
    const onlineData = res.data.online;
    const testData = res.data.test;

    if (!onlineData) return { em: res.data.em };

    return {
      em: res.data.em,
      online: this.graphDataBuild(onlineData),
      test: this.graphDataBuild(testData),
      status: res.data.status,
      msg: res.data.msg
    };
  }

  async doTaskAnalyse(param) {
    const res = await post('/v1/workflow/task_analyse', param);
    return res.data;
  }
  async accInfoRefresh(param) {
    const res = await post('/v1/workflow/doAccRefresh', param);
    const onlineData = res.data.online;
    const testData = res.data.test;

    if (!onlineData) return null;

    return {
      online: this.graphDataBuild(onlineData),
      test: this.graphDataBuild(testData)
    };
  }

  async getMergeDetail(param) {
    const res = await post('/v1/workflow/accurate', param);
    const data = res.data;
    return this.graphDataBuild(data);
  }

  async generateCase(param) {
    const res = await post('/v1/workflow/generate_case', param);
    const data = res.data;
    console.log(data);
  }

  graphDataBuild(data) {
    const fileTree = this.getTreeDTO(data.file_list);
    const apiList = data.api_list;
    const grpcList = data.grpc_list;
    const graph = this.getGraphData(data.graph);
    const order = data.order;
    return {
      fileTree,
      apiList,
      grpcList,
      graph,
      order
    };
  }

  getGraphData(baseData) {
    const { nodes, relationships } = baseData;
    const nodesRes = [{ id: '0', opacity: 0 }];
    const relationRes = [];
    if (nodes) {
      nodes.forEach(n => {
        let node = {};
        let text = '';
        switch (n.labels[0]) {
          case 'Api':
            // eslint-disable-next-line no-case-declarations
            text = n.props.path;
            node = {
              id: n.id.toString(),
              text,
              data: n.props
            };
            node.data.type = 'Api';
            node.data.text = text;
            this.nodeSetColor(node, false);
            relationRes.push({
              from: '0',
              to: n.id.toString(),
              isHide: true
            });
            nodesRes.push(node);
            return;
          case 'GrpcApi':
            text = n.props.path;
            node = {
              id: n.id.toString(),
              text,
              data: n.props
            };
            node.data.type = 'GrpcApi';
            this.nodeSetColor(node, false);
            relationRes.push({
              from: '0',
              to: n.id.toString(),
              isHide: true
            });
            nodesRes.push(node);
            return;
          case 'Function':
            node = {
              id: n.id.toString(),
              text: n.props.name,
              data: n.props
            };
            node.data.type = 'Function';
            node.data.text = n.props.name;
            this.nodeSetColor(node, false);
            nodesRes.push(node);
        }
      });
      if (relationships) {
        relationships.forEach(r => {
          relationRes.push({
            from: r.start_id.toString(),
            to: r.end_id.toString(),
            data: {
              id: r.id
            }
          });
        });
      }
    }
    return {
      rootId: '0',
      nodes: nodesRes,
      links: relationRes
    };
  }

  getTreeDTO(res) {
    const treeDTO = [];
    if (res.length === 0) {
      return [];
    }
    res.forEach(item => {
      const nodeArray = item.path.split('/');
      let children = treeDTO;
      for (let i = 0; i < nodeArray.length; i++) {
        const fileType = i === nodeArray.length - 1 ? nodeArray[i].split('.')[1] : 'folder';
        const node = {
          label: nodeArray[i],
          type: fileType
        };
        if (i === nodeArray.length - 1) {
          node.analyse = item.analyse ? item.analyse : '';
        }
        // 构建根节点
        if (children.length === 0) {
          children.push(node);
        }
        let isExist = false;
        for (const j in children) {
          if (children[j].label === node.label) {
            if (i !== nodeArray.length - 1 && !children[j].children) {
              children[j].children = [];
            }
            if (i === nodeArray.length - 1) {
              this.itemCopy(children[j], item);
            }
            children = i === nodeArray.length - 1 ? children : children[j].children;
            isExist = true;
            break;
          }
        }
        if (!isExist) {
          children.push(node);
          if (i !== nodeArray.length - 1 && !children[children.length - 1].children) {
            children[children.length - 1].children = [];
          }
          if (i === nodeArray.length - 1) {
            this.itemCopy(children[children.length - 1], item);
          }
          children = i === nodeArray.length - 1 ? children : children[children.length - 1].children;
        }
      }
    });
    return treeDTO;
  }

  itemCopy(target, dst) {
    target.status = dst.status;
    target.new_content = dst.new_content;
    target.old_content = dst.old_content;
    target.content = dst.content;
    target.function_list = dst.function_list;
    target.path = dst.path;
    target.graph = dst.graph;
    target.create_line = dst.create_line;
    target.delete_line = dst.delete_line;
  }

  // type: 1:function 2:api
  nodeSetColor(node, highLight) {
    switch (node.data.type) {
      case 'Api':
        if (highLight) {
          node.color = '#2db7f5';
          node.fontColor = '#fff';
          node.borderColor = '#2db7f5';
        } else {
          node.color = '#ecf5ff';
          node.fontColor = '#409eff';
          node.borderColor = '#b3d8ff';
        }
        break;
      case 'GrpcApi':
        if (highLight) {
          node.color = '#4da628';
          node.fontColor = '#fff';
          node.borderColor = '#4da628';
        } else {
          node.color = '#f6ffed';
          node.fontColor = '#52c41a';
          node.borderColor = '#b7eb8f';
        }
        break;
      case 'Function':
        if (highLight) {
          node.color = '#e6a23c';
          node.fontColor = '#fff';
          node.borderColor = '#e6a23c';
        } else {
          node.color = '#fdf6ec';
          node.fontColor = '#e6a23c';
          node.borderColor = '#faecd8';
        }
        break;
    }
  }
}

export default new Accurate();
